<template>
  <div class="sifat-surat-radio">
    <label class="section-label">Sifat Surat <span class="required">*</span></label>
    <a-radio-group
      :value="modelValue"
      class="radio-group-horizontal"
      :disabled="disabled"
      @change="handleChange"
    >
      <a-radio value="Biasa">Biasa</a-radio>
      <a-radio value="Terbatas">Terbatas</a-radio>
      <a-radio value="Rahasia">Rahasia</a-radio>
      <a-radio value="Sangat Rahasia">Sangat Rahasia</a-radio>
    </a-radio-group>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SifatSuratRadio',
  props: {
    modelValue: {
      type: String,
      default: 'Biasa',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const handleChange = (e) => {
      emit('update:modelValue', e.target.value)
    }

    return {
      handleChange,
    }
  },
})
</script>

<style lang="scss" scoped>
.sifat-surat-radio {
  margin-bottom: 24px;

  .section-label {
    display: block;
    font-weight: 500;
    color: #262626;
    margin-bottom: 8px;
    font-size: 14px;

    .required {
      color: #ff4d4f;
    }
  }


  /* 1. The border color when selected */
  :deep(.ant-radio-checked .ant-radio-inner) {
    border-color: #E10F28 !important;
  }

  /* 2. The inner dot color when selected */
  :deep(.ant-radio-checked .ant-radio-inner::after) {
    background-color: #E10F28 !important;
  }

  /* 3. The border color on hover */
  :deep(.ant-radio-wrapper:hover .ant-radio .ant-radio-inner),
  :deep(.ant-radio:hover .ant-radio-inner) {
    border-color: #E10F28 !important;
  }

  /* 4. (Optional) The focus glow ring/shadow */
  :deep(.ant-radio-input:focus + .ant-radio-inner) {
    box-shadow: 0 0 0 3px rgba(225, 15, 40, 0.2);
  }
  .radio-group-horizontal {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;

    :deep(.ant-radio-wrapper) {
      margin-right: 0;
    }
  }
}
</style>
